import React from 'react';
import { Box } from '@material-ui/core';

import MobileNonAuthHeader from 'sharedComponents/MobileNonAuthHeader';

import useStyles from './useStyles';

const MobileMenu = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <MobileNonAuthHeader isBuyerLocation />
    </Box>
  );
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/components/MobileMenu/MobileMenu.js